import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { SxProps } from "@mui/system";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";

// アクション系
// import { useAppDispatch } from "../app/hooks";
// import { setPageno } from "../store/modules/inputFormSlice";

// Itemタグとして使う -> 実体はDiv
const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "left",
  color: theme.palette.text.secondary,
}));

// 区切り
const hrStyle: SxProps = {
  borderWidth: 1,
  borderColor: "#d9d3c3",
  width: "90%",
  marginBottom: 4,
  marginTop: 1,
};

const inf01 = [
  "H-IX データセンターでは、ニューノーマル時代に対応したバーチャル見学をご用意しています。",
  "バーチャル見学は H-IX データセンター内を 360 度カメラで撮影した臨場感のある映像を用い、弊社営業担当者との Web 会議形式で行います。",
  "所要時間はおよそ 1 時間程度です。",
  "遠方のお客様も、直接現地までお越しいただかなくても H-IX データセンターの見学にご参加いただけますので、是非ご活用ください。",
];

const inf02 = [
  "・Web 会議による完全リモートで行います。",
  "・Web 会議ツールは Zoom を使用します。",
  "　他の Web 会議をご希望の場合はご連絡ください。",
  "・お客様はWebブラウザがインストールされたパソコンをご用意ください。",
  "・バーチャル見学のご案内、画面操作は弊社営業担当者が行います。",
];

const inf03 = [
  "①　H-IX Web サイト内のお問い合わせフォームより下記内容を記入のうえ、お申込みください。",
  "　　・お問い合わせの種類：　施設見学",
  "　　・お問い合わせ内容　：　バーチャル見学",
  "　　画面の案内に従い必要事項を入力し、最後に個人情報の取扱いについてをご確認いただき、",
  "　　「個人情報の取扱いについて同意します。」にチェックをして送信してください。",
  "②　後日、弊社からバーチャル見学参加申込書と日程後調整に関するご案内を差し上げます。",
  "③　開催日が近くなりましたらご申請された方へ Web 会議の URL、パスワードのご案内をメールいたします。",
  "④　見学開始時間になりましたら、③にてご案内した Web 会議にご参加ください。",
  "　　見学者の方がお揃いでしたらバーチャル見学を開始いたします。",
  "　　なお、開始に際してご出席者様の確認をさせていただきます。もし見学者が申請時より増えている場合などはご申告願います。",
];

const inf04 = [
  "・【必須】Web 会議用のパソコン(Microsoft Edge、Google Chrome などの Web ブラウザがインストールされているもの)",
  "・【任意】Zoom アプリケーション",
  "・【任意】Web 会議用のパソコンに接続するマイク、スピーカー、カメラ",
  "・【任意】パソコンの画面を投影できるプロジェクター、スクリーン",
  "　",
  "※【任意】としたものは必須ではございませんが、ご用意されているとより快適な環境でバーチャル見学にご参加いただけます。",
];

export default function Information() {
  // アクション系
  // const dispatch = useAppDispatch();

  function jump() {
    // 上部に強制スクロール
    // window.scrollTo(0, 0);
    // // 画面をスイッチする
    // dispatch(setPageno(2));

    window.open("https://www.h-ix.jp/contact/", "_blank");
  }

  return (
    <Container maxWidth="lg">
      <Box sx={{ flexGrow: 1 }}>
        <Grid item xs={12}>
          <Item elevation={0} sx={{ marginBottom: 6 }}>
            <Typography variant="h5" color="inherit" gutterBottom>
              H-IX データセンター バーチャル見学のご案内
            </Typography>
            <Divider sx={hrStyle} />
            {inf01.map((item) => (
              <Typography variant="body1" gutterBottom>
                {item}
              </Typography>
            ))}
          </Item>

          <Item elevation={0} sx={{ marginBottom: 6 }}>
            <Typography variant="h5" color="inherit" gutterBottom>
              バーチャル見学形式
            </Typography>
            <Divider sx={hrStyle} />
            {inf02.map((item) => (
              <Typography variant="body1" gutterBottom>
                {item}
              </Typography>
            ))}
          </Item>

          <Item elevation={0} sx={{ marginBottom: 6 }}>
            <Typography variant="h5" color="inherit" gutterBottom>
              バーチャル見学開始までの流れ
            </Typography>
            <Divider sx={hrStyle} />
            {inf03.map((item) => (
              <Typography variant="body1" gutterBottom>
                {item}
              </Typography>
            ))}
          </Item>

          <Item elevation={0} sx={{ marginBottom: 6 }}>
            <Typography variant="h5" color="inherit" gutterBottom>
              お客様にご用意いただくもの
            </Typography>
            <Divider sx={hrStyle} />
            {inf04.map((item) => (
              <Typography variant="body1" gutterBottom>
                {item}
              </Typography>
            ))}
          </Item>

          <Item elevation={0} sx={{ marginBottom: 6 }}>
            <Typography variant="h5" color="inherit" gutterBottom>
              バーチャル見学イメージ
            </Typography>
            <Divider sx={hrStyle} />
            <img src="./vr_sample1.jpg" alt="バーチャル見学イメージ"></img>
          </Item>

          <Item elevation={0} sx={{ marginBottom: 1 }}>
            <Typography variant="h5" color="inherit" gutterBottom>
              バーチャル見学のお申し込み
            </Typography>
            <Divider sx={hrStyle} />

            <Typography variant="body1" gutterBottom>
              お申し込みの際は、下記内容をご入力ください。
            </Typography>
            <Typography variant="body1" gutterBottom>
              ・お問い合わせの種類：　施設見学
            </Typography>
            <Typography variant="body1" gutterBottom>
              ・お問い合わせ内容　：　バーチャル見学
            </Typography>
          </Item>

          <Item elevation={0} sx={{ marginBottom: 12 }}>
            <Button
              variant="outlined"
              sx={{ marginTop: 2 }}
              onClick={() => {
                jump();
              }}
            >
              お問い合わせフォームを開く（新しい画面で開きます）
            </Button>
          </Item>
        </Grid>
      </Box>
    </Container>
  );
}
